<template>
    <list-page title="日志管理" :api="searchUrl" :searchParam="searchParam" :showPager="true" ref="log">
        <template v-slot:search>
            <div class="block">
                <el-input size="mini" v-model="searchParam.Key"></el-input>
            </div>
        </template>
        <el-table-column prop="CreatedTime" label="时间">
            <template #default="{ row }">{{ formatData(row.CreatedTime) }}</template>
        </el-table-column>
        <el-table-column prop="CreatedUserCode" label="账号"></el-table-column>
        <el-table-column prop="CreatedUserName" label="名称"></el-table-column>
        <el-table-column prop="LogDescType" label="模块"></el-table-column>
        <el-table-column prop="LogDesc" label="操作"></el-table-column>
    </list-page>
</template>
<script>
export default {
    name: "Role",
    data() {
        return {
            searchParam: {
                Key: "",
            },
            searchUrl: "/SysMgr/GetLogs",
        };
    },
    methods: {
        formatData(v) {
            return new Date(v).format("yyyy-MM-dd hh:mm:ss");
        },
    },
};
</script>
